import { text_size } from "@/app/utils/MixinSize";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { useMediaQuery } from "@mui/material";
import { theme } from '@/app/utils/Common';
import styled from "styled-components";

const DivNoInfo = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 4px 4px;
  ${text_size(15)}
  font-weight: 500;
  padding: 50px 10px;

  div{
    text-align: center;
    ${text_size(15)}
  }
`;


const NoInfoLink = styled.a`
  color: #122C68;
  &:hover {
    text-decoration:underline;
}
`;

const DivTitle = styled.div`
  font-weight: 700;
  padding-bottom: 12px;
`;

const DivMsg = styled("div")<{ $isMobile?: boolean }>(({ $isMobile }) => ({
  paddingBottom: $isMobile ? "12px" : "unset"
}));

export default function NoInformation(prop:any) {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const link = lang.langType === LANGTYPE_EN ? "https://www.hkjc.com/home/english/index.aspx" : "https://www.hkjc.com/home/chinese/index.aspx";

  return (
    <DivNoInfo id="DivNoInfo" style={prop?.sx}>
      <DivTitle>{t('no_information')}</DivTitle>
      <DivMsg $isMobile={isMobile}>{t('no_information_sub')}</DivMsg>
      <div>&gt;&gt; <NoInfoLink href={link} target="_self">{t('no_information_link')}</NoInfoLink></div>
    </DivNoInfo>
  );
}